<script setup lang="ts">
	defineProps<{
		title?: string
		titleClass?: ClassContext
		descClass?: ClassContext
		description?: string
		useButton?: boolean
		iconPosition?: 'top' | 'bottom'
	}>()
</script>

<template>
	<div class="flex flex-col items-center justify-center">
		<slot v-if="iconPosition === 'top'" name="icon" />
		<slot name="title">
			<h4
				v-show="title"
				class="text-lg font-semibold capitalize"
				:class="titleClass || 'text-gray-700 md:text-[24px]'"
			>
				{{ title }}
			</h4>
		</slot>
		<slot name="description">
			<p
				v-show="description"
				class="mx-auto mb-10 text-center text-sm font-normal leading-tight text-gray-500 md:text-base"
				:class="descClass"
			>
				{{ description }}
			</p>
		</slot>
		<slot v-if="!iconPosition || iconPosition === 'bottom'" name="icon" />

		<slot v-if="useButton" name="button" />
	</div>
</template>
